<template>
  <LoginWrapper>
    <template v-slot:main>
      <h2 class="login-title">Enter the details to create your account</h2>
      <FormGroup v-bind:form="entryForm">
        <div class="row input-row mt-4 mb-2">
          <div class="col-12">
            <FormInputText
              placeholder="Name"
              v-model="name"
              field="name"
              class="login-input"
              icon="fa-user"
            />
          </div>
        </div>
        <div class="row input-row my-2">
          <div class="col-12">
            <FormInputText
              placeholder="Email"
              v-model="email"
              field="email"
              class="login-input"
              icon="fa-envelope"
            />
          </div>
        </div>
        <div class="row input-row my-2">
          <div class="col-12">
            <FormInputText
              type="password"
              placeholder="Password"
              v-model="password"
              field="password"
              class="login-input"
              icon="fa-lock"
            />
          </div>
        </div>
        <div class="row input-row my-2">
          <div class="col-12">
            <FormInputText
              placeholder="Company Name"
              v-model="companyName"
              field="companyName"
              class="login-input"
              icon="fa-user-circle"
            />
          </div>
        </div>
        <div class="row input-row my-2" v-if="!appIsLiveSite">
          <div class="col-12">
            <FormInputText
              placeholder="Developer Code"
              v-model="developerCode"
              field="developerCode"
              class="login-input"
              icon="fa-ticket"
            />
          </div>
        </div>
        <div class="row input-row my-4">
          <div class="col-12 text-left">
            <FormCheckbox v-model="agreeTerms" field="agreeTerms" />
            &nbsp;&nbsp;I&apos;ve read and agreed to the <a href="/about/terms" target="_blank" class="font-weight-bold">terms of use</a> and <a href="/about/privacy" target="_blank" class="font-weight-bold">privacy policy</a>
          </div>
        </div>
        <div class="row input-row my-4">
          <div class="col-12">
            <FormButton
              :loading="submitting" 
              @click="onCreateAccount"
              class="btn-lg block full-width login-submit">CREATE ACCOUNT</FormButton>
          </div>
        </div>
        <div class="row input-row">
          <div class="col-12 text-left login-recaptcha-notice">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
            <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
          </div>
        </div>
      </FormGroup>
    </template>
    <template v-slot:sidebar>
      <div class="login-side-title">Welcome</div>
        Already have an account?<br />
        <div class="mt-2">
          <router-link to="/login" class="login-sidebar-button">Sign In</router-link>
        </div>
    </template>
  </LoginWrapper>
</template>


<script>
import form from '@/mixins/form'
import LoginWrapper from '@/modules/core/components/loginWrapper'

export default {
  name: 'AccountRegistration',
  mixins: [form],
  components: {
    LoginWrapper,
  },
  data: () => {
    return {
      name: '',
      email: '',
      password: '',
      companyName: '',
      developerCode: '',      // Required for staging site
      agreeTerms: false,
      entryForm: {},
      submitting: false
    };
  },
  computed: {
    appIsLiveSite() {
      return this.$glass.isLiveSite
    },
  },
  methods: {
    async onCreateAccount() {
      this.$data.entryForm = this.clearFormResponse()
      this.submitting = true

      try {
        // Ensure ReCaptcha is loaded & get the token
        await this.$recaptchaLoaded()
        let recaptchaToken = await this.$recaptcha('register')

        this.$api.post('/account/registration/signup', {
            name: this.name,
            email: this.email,
            password: this.password,
            companyName: this.companyName,
            agreeTerms: this.agreeTerms,
            recaptchaToken: recaptchaToken,
            developerCode: this.developerCode
          })
          .then(response => {
            this.$router.push({
              name: 'Login',
              params: {
                successTitle: 'Account Registered',
                successMessage: 'Please check your email inbox for the verification email'
              }
            })
          })
          .catch(err => {
            // Process errors
            this.$data.entryForm = this.processFormResponse(err);
          })
          .finally(() => {
            this.submitting = false
          })
      } catch(err) {
        this.$data.entryForm = this.processFormResponse('Error while processing registration. If this continues, please check your internet connection or contact Synergy Software')
        this.submitting = false
      }
    }
  }
}
</script>